import request from '@/utils/request'

// 用户登录：获取用户验证码
export function getCode() {
  return request({
    url: '/hobolite-api/web/verificationCode',
    method: 'get'
  })
}

// 用户登录：用户登录
export function userLogin(data) {
  return request({
    url: '/hobolite-api/web/login',
    method: 'post',
    data
  })
}

// 系统账号管理-用户拥有的菜单
export function userMenu() {
  return request({
    url: '/hobolite-api/web/userMenu',
    method: 'get'
  })
}

// 系统账号管理-系统账户列表
export function userList(data) {
  return request({
    url: '/hobolite-api/web/userList',
    method: 'post',
    data
  })
}

// 系统账号管理-角色id和名称下拉列表
export function allRole() {
  return request({
    url: '/hobolite-api/web/allRole',
    method: 'get'
  })
}

// 系统账号管理-新建账号
export function addUser(data) {
  return request({
    url: '/hobolite-api/web/addUser',
    method: 'post',
    data
  })
}

// 系统账号管理-编辑用户
export function updateUserInfo(data) {
  return request({
    url: '/hobolite-api/web/updateUserInfo',
    method: 'post',
    data
  })
}

// 系统账号管理-更改用户启用停用状态
export function updateUserStatus(data) {
  return request({
    url: '/hobolite-api/web/updateUserStatus',
    method: 'post',
    data
  })
}

// 系统账号管理-更改用户启用停用状态
export function updateUserPassword(data) {
  return request({
    url: '/hobolite-api/web/updateUserPassword',
    method: 'post',
    data
  })
}

// 固件管理-固件列表查询
export function firmwareList(data) {
  return request({
    url: '/hobolite-api/web/firmwareList',
    method: 'post',
    data
  })
}

// 固件管理-产品型号下拉框列表
export function allProduct() {
  return request({
    url: '/hobolite-api/web/allProduct',
    method: 'get'
  })
}

// 固件管理-更改上架下架状态
export function updateFirmwareStatus(data) {
  return request({
    url: '/hobolite-api/web/updateFirmwareStatus',
    method: 'post',
    data
  })
}

// 固件管理-新增固件
export function addFirmware(data) {
  return request({
    url: '/hobolite-api/web/addFirmware',
    method: 'post',
    data
  })
}

// 固件管理-编辑固件
export function updateFirmwareInfo(data) {
  return request({
    url: '/hobolite-api/web/updateFirmwareInfo',
    method: 'post',
    data
  })
}

// 终端管理-终端列表查询
export function terminalList(data) {
  return request({
    url: '/hobolite-api/web/terminalList',
    method: 'post',
    data
  })
}

// 终端管理-终端升级记录
export function terminalUpgradeRecord(data) {
  return request({
    url: '/hobolite-api/web/terminalUpgradeRecord',
    method: 'post',
    data
  })
}

// 终端管理-终端详情查询
export function terminalDetail(data) {
  return request({
    url: '/hobolite-api/web/terminalDetail',
    method: 'post',
    data
  })
}

// 产品管理-产品列表查询
export function productList(data) {
  return request({
    url: '/hobolite-api/web/productList',
    method: 'post',
    data
  })
}

// 固件管理-固件下拉列表查询
export function firmwareDownList() {
  return request({
    url: '/hobolite-api/web/firmwareDownList',
    method: 'post'
  })
}

// 产品管理-新增产品
export function addProduct(data) {
  return request({
    url: '/hobolite-api/web/addProduct',
    method: 'post',
    data
  })
}

// 产品管理-编辑产品
export function updateProduct(data) {
  return request({
    url: '/hobolite-api/web/updateProduct',
    method: 'post',
    data
  })
}

// 产品管理-升级记录
export function productUpgradeRecord(data) {
  return request({
    url: '/hobolite-api/web/productUpgradeRecord',
    method: 'post',
    data
  })
}

// 角色管理-列表查询
export function roleList(data) {
  return request({
    url: '/hobolite-api/web/roleList',
    method: 'post',
    data
  })
}

// 角色管理-更改状态
export function updateRoleStatus(data) {
  return request({
    url: '/hobolite-api/web/updateRoleStatus',
    method: 'post',
    data
  })
}

// 角色管理-角色拥有的菜单
export function roleMenuTreeselect(data) {
  return request({
    url: '/hobolite-api/web/roleMenuTreeselect',
    method: 'post',
    data
  })
}

// 角色管理-新建角色
export function roleAdd(data) {
  return request({
    url: '/hobolite-api/web/roleAdd',
    method: 'post',
    data
  })
}

// 角色管理-编辑角色
export function roleUpdate(data) {
  return request({
    url: '/hobolite-api/web/roleUpdate',
    method: 'post',
    data
  })
}

// 角色管理-所有菜单树
export function treeselect() {
  return request({
    url: '/hobolite-api/web/treeselect',
    method: 'get'
  })
}

// 反馈管理-列表查询
export function feedbackList(data) {
  return request({
    url: '/hobolite-api/web/feedbackList',
    method: 'post',
    data
  })
}

// 反馈管理-列表查询
export function feedbackDetail(data) {
  return request({
    url: '/hobolite-api/web/feedbackDetail',
    method: 'post',
    data
  })
}

// 用户隐私协议管理-新增协议
export function addPrivatePolicy(data) {
  return request({
    url: '/hobolite-api/web/addPrivatePolicy',
    method: 'post',
    data
  })
}

// 用户隐私协议管理-最新隐私协议
export function latestPrivatePolicy() {
  return request({
    url: '/hobolite-api/web/latestPrivatePolicy',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/hobolite.js